export default __webpack_public_path__ + "static/media/slide5.16bf933f.jpg";